module.exports = __webpack_public_path__ + "static/media/1-item-e.22c01986.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/1-item-e.jpg
// module id = 1156
// module chunks = 33